import firebase from "firebase"

// TODO: local firebase dev server?
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_apiKey,
  authDomain: process.env.VUE_APP_FIREBASE_authDomain,
  databaseURL: process.env.VUE_APP_FIREBASE_databaseURL,
  projectId: process.env.VUE_APP_FIREBASE_projectId,
  storageBucket: process.env.VUE_APP_FIREBASE_storageBucket,
  messagingSenderId: process.env.VUE_APP_FIREBASE_messagingSenderId
}

const app = firebase.initializeApp(firebaseConfig)
const db = app.database()
const storage = app.storage()
const auth = app.auth()
const TIMESTAMP = firebase.database.ServerValue.TIMESTAMP

export { app, db, storage, auth, firebase, TIMESTAMP }
